import Page from "../../components/Page";

import "./styles.scss";

export default function Recommended() {
  return (
    <Page title="Recommendended Resources">
   
      <h3>BOOKS</h3>
      <p>
        These books are available in nearly all public libraries and bookstores.
        They are also available at the book sales table at all Earthsave events.
      </p>
      <br />
      <p>
        <b>"FOOD REVOLUTION"</b>, by Earthsave founder John Robbins, gives
        current, well-documented information on all the best reasons, including
        health, animal protection, and ecology, to adopt a plant centered diet.
        Food Revolution is similar in style and content to Robbins' classic best
        seller DIET FOR A NEW AMERICA.
      </p>
      <br />
      <p>
        <b>"THE CHINA STUDY"</b>, by T. Colin Campbell, PhD, details some of the
        most compelling scientific evidence available on the connection between
        diet and a whole host of chronic diseases that are currently shortening
        Americans’ lives. Dr. Campbell is the nutritional biochemist from
        Cornell University who led the Cornell/Oxford/China Health Project,
        which is the most comprehensive large study ever undertaken of the
        relationship between diet and disease.
      </p>
      <br />
      <p>
        <b>"THE NEW BECOMING VEGETARIAN"</b>, by Vesanto Melina, RD; Brenda
        Davis, RD, is a comprehensive and well-researched manual for achieving
        optimal nutrition at all stages of life. It includes more than 50 great
        tasting, easy recipes.
      </p>
      <br />
      <p>
        <b>"THE WORLD PEACE DIET"</b>, by musician/composer, educator, and Zen
        Buddhist Master Will Tuttle, PhD, examines, comprehensively, the link
        between the violence on our dinner plates and a whole, massive cycle of
        violence in the world today. Tuttle sees animal agriculture as the
        central link to a broad range of problems - psychological, social, and
        spiritual, as well as health and environmental. The book offers powerful
        ways we can all experience healing and peace and contribute to a
        positive transformation of human consciousness.
      </p>
      <br />
      <p>
        <b>OUR FOOD OUR FUTURE</b> is an excellent guide to the diverse reasons
        for shifting to a whole foods, plant based diet. You may view the whole
        booklet or download a copy for free by going to . You can also purchase
        a copy for just one dollar at the book table at Earthsave Baltimore
        potluck events.
      </p>
      <br />
      <p>
        <b>FLIERS & HANDOUTS</b>
      </p>
      <br />
      <p>
        You may download and print the items listed as "attachments" at the
        bottom of this page.
      </p>
      <br />
      <p>
        The first item is a flier with information on the next several Earthsave
        events. Page should be printed on front and reverse and folded to make
        small brochure. There's helpful information on popular local veg
        restaurants and nutrition professionals, as well as some good general
        information about the benefits of a whole food, plant-based diet.
      </p>
      <br />
      <p>
        The second item lists the nutritional recommendations of Michael Greger,
        MD, who is a much respected speaker and author. He's a general
        practitioner specilizing in clinical nutrition. Each year he reads all
        of the nutritional journals that are published in English and reveals
        his findings and recommendations.
      </p>
      <br />
      <p>
        The third item is an article by Dr. Dean Ornish about the connection
        between diet and the most common and deadly chronic diseases. The
        clinial studies of Dr. Ornish have shown conclusively that dietary
        change can not only prevent but can reverse even severe coronary artery
        disease.
      </p>
      <br />
      <p>
        <b>LINKS to Helpful Websites on...</b>
      </p>
      <br />
      <p>
        <b>~VEGETARIANISM & VEGANISM~</b>
      </p>
      <br />
      <p>
        <b>Earthsave International</b> offers an opportunity to learn and grow
        with VegPledge, and also features Earthsave TV online educational videos
        and many helpful publications you may read for free online.
      </p>
      <a href="https://www.earthsave.org" target="_blank" rel="noreferrer">
        http://earthsave.org/
      </a>
      <br />
      <br />
      <p>
        <b>North American Vegetarian Society</b>hosts Vegetarian Summerfest, in
        Johnstown, PA, one of the best educational opportunites available.
      </p>
      <a href="http://www.navs-online.org/" target="_blank" rel="noreferrer">
        http://www.navs-online.org/
      </a>
      <br />
      <br />
      <p>
        <b>Vegetarian Resource Group</b> has a real helpful website that
        includes a nationwide guide to vegetarian and veg-friendly restaurants.
      </p>
      <a href="http://www.vrg.org" target="_blank" rel="noreferrer">
        {" "}
        http://www.vrg.org
      </a>
      <br />
      <br />
      <p>
        <b>VegSource</b> website offers free online viewings of many helpful
        educational videos.
      </p>
      <a href="https://vegsource.com/" target="_blank" rel="noreferrer">
        {" "}
        https://vegsource.com/
      </a>
      <br />
      <br />
      <p>
        <b>T. Colin Campbell Foundation Newsletter:</b>Dr. Campbell is the
        nutritional biochemist from Cornell University who led the huge and
        comprehensive Cornell/Oxford/China Health Project, and who wrote the
        book <b>China Study</b>. That study provided some of the best scientific
        documentation showing the health sustaining effects of a plant centered
        diet. The newsletter lets us connect with Dr. Campbell and learn about
        healthy eating. See . You may subscribe by writing
        info=tcolincampbell.org@mcsv9.net.
      </p>
      <h4>~ANIMAL ADVOCACY~</h4>
      <br />
      <p>
        <b> Humane League of Baltimore</b> organizes peaceful demonstrations,
        food samplings, and social gatherings to educate people and help end
        animal suffering. http://www.baltimoreanimalrights.com/ THIS LINK
        DOESN'T WORK{" "}
      </p>
      <br />
      <p>
        <b>Vegan Outreach</b> publishes a variety of educational pamphlets,
        including "Why Vegan", and "Even if You Like Meat". Their Adopt-a-Campus
        program has been highly effective outreach effort.
      </p>
      <a href="https://veganoutreach.org/" target="_blank" rel="noreferrer">
        https://veganoutreach.org/
      </a>
      <br />
      <br />
      <p>
        <b>Compassion Over Killing,</b> in Washington, DC, is one of the most
        effective nonprofits working to promote vegetarianism and help farmed
        animals.{" "}
      </p>
      <a href="http://www.cok.net/" target="_blank" rel="noreferrer">
        http://www.cok.net/
      </a>
      <br />
      <br />
      <p>
        <b>Humane Society of the US</b> is doing great work to help all animals,
        and does much to help protect farmed animals.
      </p>
      <a href="http://www.hsus.org/" target="_blank" rel="noreferrer">
        http://www.hsus.org/
      </a>
      <br />
      <br />
      <h4>~ANIMAL SANCTUARIES~ </h4>
      <br />
      <p>
        <b>Poplar Spring Animal Sanctuary,</b> in Poolesville, MD, is the
        nearest farmed animal sanctuary to Baltimore.
      </p>
      <a href="http://www.animalsanctuary.org/" target="_blank" rel="noreferrer">
        http://www.animalsanctuary.org/
      </a>
      <br />
      <br />
      <p>
        <b>Farm Sanctuary </b> has locations in California and in New York and
        offers frequent educational opportunities.
      </p>
      <a href="https://www.farmsanctuary.org/" target="_blank" rel="noreferrer">
        https://www.farmsanctuary.org/
      </a>
    </Page>
  );
}
